// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage'; // Add this import

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDmgU5GmPOQwsJTyjMPcLioTd23_WNo508",
  authDomain: "bouldou-d4eb5.firebaseapp.com",
  projectId: "bouldou-d4eb5",
  storageBucket: "bouldou-d4eb5.firebasestorage.app",
  messagingSenderId: "196805929288",
  appId: "1:196805929288:web:7059c4d579f8eea6b9ab7d",
  measurementId: "G-QWERTV6SMM"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app); // Add this export